import 'jquery';
import inView from 'in-view/dist/in-view.min';
import {DMI_SELECTOR} from './constants';
import {create} from './create';

function importConditionInView(elements, container, stats) {
    inView(this.filter).on('enter', () => {
        DMI.importModule(stats.moduleName, container, true);
    });

    return false;
}

function importConditionDocumentReady(elements, container, stats) {
    $(window).on('load', () => {
        DMI.importModule(stats.moduleName, container, true);
    });

    return false;
}

export const JS_IMPORT_INITIALIZED_KEYS = [
    // configChart.initializedKey,
];

export const DMI = create({
    selector: DMI_SELECTOR,
    debug: true,
    modules: {
        demo: {
            filter: '[data-demo]',
            importFn: () => import('../modules/demo')
        },
        magnificPopup: {
            filter: '[data-mfp]',
            importFn: () => import('../modules/magnific-popup')
        },
        formItem: {
            filter: 'form',
            importFn: () => import('../modules/form-item')
        },
        select2: {
            filter: '[data-initialize-select2]',
            importFn: () => import('../modules/select2/index')
        },
        menu: {
            filter: '[data-menu]',
            importFn: () => import('../modules/menu/index')
        },
        dropdown: {
            filter: '[data-dropdown]',
            importFn: () => import('../modules/dropdown')
        },
        table: {
            filter: '[data-table]',
            importFn: () => import('../modules/tabulator')
        },
        customizeTablePopup: {
            filter: 'CustomizeTable',
            importFn: () => import('../modules/react_src/customize-table')
        },
        customizeButton: {
            filter: 'CustomizeButton',
            importFn: () => import('../modules/react_src/customize-button')
        },
        minMaxButton: {
            filter: 'MinMaxButton',
            importFn: () => import('../modules/react_src/MinMaxButton')
        },
        RecieptCards: {
            filter: 'RecieptCards',
            importFn: () => import('../modules/react_src/ReceiptCards')
        },
        RecieptFilterFields: {
            filter: '[data-receipt-filter-fields]',
            importFn: () => import('../modules/react_src/ReceiptFilterFields')
        },
        sendEmail: {
            filter: 'sendEmail',
            importFn: () => import('../modules/react_src/SendToEmail')
        },
        deleteReceipt: {
            filter: 'deleteReceipt',
            importFn: () => import('../modules/react_src/DeleteToReceipt')
        },
        datepicker: {
            filter: '[data-datepicker]',
            importFn: () => import('../modules/daterangepicker'),
            // importCondition: importConditionDocumentReady
        },
        clipboard: {
            filter: '[data-copy]',
            importFn: () => import('../modules/clipboard')
        },
        OpenStreetMap: {
            filter: '[data-maps]',
            importFn: () => import('../modules/maps/index')
        },
        tabs: {
            filter: '[data-tabs]',
            importFn: () => import('../modules/tabs/index')
        },
        createReceipt: {
            filter: '[data-receipt]',
            importFn: () => import('../modules/create-receipt/logic'),
            // importCondition: importConditionDocumentReady
        },
        managerCard: {
            filter: '[data-manager-card]',
            importFn: () => import('../modules/react_src/ManagerCard')
        },
        editReceiptContainer: {
            filter: '[data-receipt-edit-container]',
            importFn: () => import('../modules/react_src/edit-receipt-container')
        },
        editReceiptPopup: {
            filter: 'EditReceiptPopup',
            importFn: () => import('../modules/react_src/edit-receipt-popup')
        },
        timepicker: {
            filter: '[data-timepicker]',
            importFn: () => import('../modules/timepicker'),
            // importCondition: importConditionDocumentReady
        },
        tooltip: {
            filter: '[data-tooltip]',
            importFn: () => import('../modules/tooltip')
        },
        printReceipt: {
            filter: '[data-print-receipt]',
            importFn: () => import('../modules/print-receipt')
        },
        receiptTemplates: {
            filter: '[data-templates]',
            importFn: () => import('../modules/templates/index')
        },
        receiptDrafts: {
            filter: '[data-drafts]',
            importFn: () => import('../modules/templates/drafts')
        },
        inputmask: {
            filter: '[data-inputmask]',
            importFn: () => import('../modules/inputmask')
        },
        toggle: {
            filter: '[data-toggle]',
            importFn: () => import('../modules/toggle/index')
        },
        pickUp: {
            filter: '[data-pick-up]',
            importFn: () => import('../modules/orders/pick-up')
        },
        requestDelivery: {
            filter: '[data-delivery-wrapper]',
            importFn: () => import('../modules/orders/delivery')
        },
        showPassword: {
            filter: '[data-password]',
            importFn: () => import('../modules/show-password/index')
        },
        usersSettings: {
            filter: '[data-users]',
            importFn: () => import('../modules/users/user-settings')
        },
        apiKeys: {
            filter: '[data-api-key]',
            importFn: () => import('../modules/users/api-keys')
        },
        childOrganizations: {
            filter: '[data-subsidiary]',
            importFn: () => import('../modules/users/subsidiary')
        },
        childUser: {
            filter: '[data-child-user]',
            importFn: () => import('../modules/users/child-user')
        },
        notifications: {
            filter: '[data-notifications]',
            importFn: () => import('../modules/notifications')
        },
        changePoints: {
            filter: '[data-change-points]',
            importFn: () => import('../modules/loyalty/change-points')
        },
        cargoInstruction: {
            filter: '[data-cargo-instruction]',
            importFn: () => import('../modules/cargo/instruction')
        },
        tariffLocality: {
            filter: '[data-tariff-locality]',
            importFn: () => import('../modules/cargo/tariff')
        },
        invoicesTable: {
            filter: '[data-invoices-table]',
            importFn: () => import('../modules/invoices')
        },
        cardCustomer: {
            filter: '[data-card-customer]',
            importFn: () => import('../modules/document/card-customer')
        },
        scroll: {
            filter: '[data-scroll-to]',
            importFn: () => import('../modules/scroll-to')
        },
        vchasno: {
            filter: '[data-vchasno-wrapper]',
            importFn: () => import('../modules/document/vchasno')
        },
        loyaltySidebar: {
            filter: '[data-loyalty-sidebar]',
            importFn: () => import('../modules/loyalty-sidebar')
        },
        home: {
            filter: '[data-home]',
            importFn: () => import('../modules/home/index')
        },
        unpaidReceiptsLogic: {
            filter: '[data-unpaid-receipts]',
            importFn: () => import('../modules/unpaid')
        },
        userInvoices: {
            filter: '[data-user-invoices]',
            importFn: () => import('../modules/finances/invoices')
        },
        userCards: {
            filter: '[data-user-cards]',
            importFn: () => import('../modules/finances/cards')
        },
        formance: {
            filter: '[data-formance]',
            importFn: () => import('../modules/formance')
        },
        dropzone: {
            filter: '[data-dropzone]',
            importFn: () => import('../modules/dropzone')
        },
        promocode: {
            filter: '[data-promocode]',
            importFn: () => import('../modules/promocode')
        },
        receipts: {
            filter: '[data-receipts]',
            importFn: () => import('../modules/receipts/index')
        },
        userContracts: {
            filter: '[data-user-contracts]',
            importFn: () => import('../modules/document/contract')
        },
        analitics: {
            filter: '[data-analitics]',
            importFn: () => import('../modules/analitics/index')
        },
        userContacts: {
            filter: '[data-user-contacts]',
            importFn: () => import('../modules/create-receipt/contacts')
        },
        tips: {
            filter: '[data-tips]',
            importFn: () => import('../modules/finances/tips')
        },
    }
});